// @ts-nocheck
import { useEffect } from "react";
import { emitCurrentUserState } from "../../services/apiService";
import { useSelector } from "react-redux";
import { getDeviceId } from "../../services/indexDb";

export const useBackAndForeGround = () => {
  const { userId } = useSelector((state) => state?.auth);
  const deviceId = getDeviceId();

  useEffect(() => {
    const API_URL = window.location.origin;

    // works on chrome and safari but not on brave
    const handleVisibilityChange = () => {
      try {
        if (document.hidden) {
          emitCurrentUserState({ state: "BACKGROUND" });
        } else {
          emitCurrentUserState({ state: "FOREGROUND" });
        }
      } catch (e) {}
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // The legacy code had a navigator.sendBeacon to `${API_URL}/user/state` here
    // with a TODO "update with a url" — that endpoint never actually existed on the backend.
    // We keep it as a reference but don't call it, to avoid generating 404s in the console.
    // If the backend ever exposes /user/state, just re-enable it:
    //   navigator.sendBeacon(`${API_URL}/user/state`, JSON.stringify({ userId, deviceId, state: "BACKGROUND" }));
    void API_URL;
    void deviceId;
    void userId;

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [userId, deviceId]);
};